// components/SectionTitle.jsx
export default function SectionTitle({ children, rightContent }) {
  return (
    <div className="flex items-center justify-between px-4 pt-5 pb-3">
      <h2 className="text-lg font-bold uppercase">{children}</h2>
      {rightContent ? (
        <div className="text-xs text-gray-500">{rightContent}</div>
      ) : (
        <span className="text-gray-400 text-2xl">›</span>
      )}
    </div>
  );
}